/* Agent Apps (new), the Agent Apps page at /pages/agent-apps since 2026-10-19 (templates/page.apps.json), after the moments
   kit (assets/cg-moments.js, window.CGMO). Four parts: (1) the opening store, where three Agent Apps sort the menu,
   write the names and add a label, then the work is approved and the light settles under "one job"; (2) the three
   steps in one app window, played once in view, each number replaying its screen; (3) the constellation, the page's
   one pinned moment: one category at a time on native scroll; (4) the list's category chips. Everything plays once,
   moves only pictures, and is finished and still when motion is off (CGMO.live false). The Pause animations button
   (cg:motion) switches it in place: paused, the timers stop and the constellation is unpinned; played again, what was
   shown stays finished and the constellation pins where it fits. Words live in the sections. */
(function () {
  'use strict';
  var MO = window.CGMO;
  var PAGE = document.getElementById('pg-apps');
  if (!MO || !PAGE) return;
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function later(fn, s) { return setTimeout(fn, s * 1000); }
  function on(els, cls) { els.forEach(function (el) { el.classList.add(cls || 'on'); }); }
  function off(els, cls) { els.forEach(function (el) { el.classList.remove(cls || 'on'); }); }

  // ---- (1) the opening: once, after the page has loaded and the main thread is free
  function opening(sec) {
    var win = sec.querySelector('.an-store-wrap');
    var glow = all(sec, '.mo-gw'), timers = [];
    if (win) document.addEventListener('cg:motion', function () {
      if (MO.live) on(all(win, '.an-chip'), 'in');
      else { timers.forEach(clearTimeout); timers = []; }
    });
    if (!win || !MO.live) { on(glow); return; }
    var ok = win.querySelector('.an-s-ok');
    function part(k) { return all(win, '[data-k="' + k + '"]').filter(function (el) { return !el.classList.contains('an-chip'); }); }
    function chip(k) { return win.querySelector('.an-chip[data-k="' + k + '"]'); }
    var order = ['menu', 'names', 'labels'];
    function play() {
      order.forEach(function (k, i) {
        var c = chip(k);
        timers.push(later(function () { if (c) c.classList.add('in'); }, 0.2 + i * 0.25));
        timers.push(later(function () {
          part(k).forEach(function (el) { el.classList.add('on'); if (el.classList.contains('mo-x')) el.classList.add('flash'); });
          if (c) c.querySelector('.mo-x').classList.add('on');
        }, 1.3 + i * 0.75));
      });
      timers.push(later(function () { if (ok) ok.classList.add('on'); }, 3.9));
      timers.push(later(function () { on(glow); }, 4.3));
    }
    var go = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 120); })(play, { timeout: 900 }); };
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }

  // ---- (2) three steps, one app window
  function steps(sec) {
    var app = sec.querySelector('.an-app');
    if (!app) return;
    var btns = all(sec, '.an-step-b'), items = all(sec, '.an-step'), screens = all(app, '.an-st'), timers = [], restT = 0;
    // a screen not on show rests once its fade is over: its busy dots stop (assets/cg-apps-new.css). Hidden, the
    // browser cannot hand them to the compositor, so they kept the page's main thread busy every frame (#81)
    function rest() { restT = 0; screens.forEach(function (s) { if (!s.classList.contains('an-st-' + app.getAttribute('data-step'))) s.classList.add('an-st-rest'); }); }
    function show(n, play) {
      app.setAttribute('data-step', String(n));
      screens.forEach(function (s) { if (s.classList.contains('an-st-' + n)) s.classList.remove('an-st-rest'); });
      clearTimeout(restT); restT = later(rest, 0.5);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-n') === String(n) ? 'true' : 'false'); });
      items.forEach(function (li) { li.classList.toggle('on', li.getAttribute('data-n') === String(n)); });
      var st = app.querySelector('.an-st-' + n);
      if (!st) return;
      st.classList.remove('go');
      var okb = st.querySelector('.mo-ok');
      if (okb) okb.classList.remove('on');
      if (!play) { st.classList.add('go'); if (okb) okb.classList.add('on'); return; }
      void st.offsetWidth;
      requestAnimationFrame(function () { st.classList.add('go'); });
      if (okb) timers.push(later(function () { okb.classList.add('on'); }, 1.25));
    }
    function stop() { timers.forEach(clearTimeout); timers = []; }
    btns.forEach(function (b) { b.addEventListener('click', function () { stop(); show(+b.getAttribute('data-n'), MO.live); }); });
    // paused: the screen on show is finished and still; played again, every screen is finished until a number is pressed
    document.addEventListener('cg:motion', function () {
      if (MO.live) on(all(app, '.an-st'), 'go');
      else { stop(); show(+app.getAttribute('data-step') || btns.length || 3, false); }
    });
    if (!MO.live) { show(btns.length || 3, false); return; }
    show(1, false);
    all(app, '.an-st-1 .mo-x').forEach(function (x) { x.classList.remove('on'); });
    app.querySelector('.an-st-1').classList.remove('go');
    MO.when(sec, 0.62, function () {
      show(1, true);
      timers.push(later(function () { show(2, true); }, 2.6));
      timers.push(later(function () { show(3, true); }, 5.8));
    });
  }

  // ---- (3) the constellation: one category at a time, then all of them
  function stars(sec) {
    var cats = all(sec, '.an-cat'), scenes = all(sec, '.an-sc'), nodes = all(sec, '.an-node'), rays = all(sec, '.an-ray');
    // the light's stretch of ring is set on the drawing of the ring alone, so moving it restyles a few lines, not the
    // whole moment (#81)
    var light = sec.querySelector('.an-ring-svg') || sec.querySelector('.an-ring'), pin = sec.querySelector('.an-pin');
    var n = cats.length - 1, cur = -1, timers = [], restT = 0;
    function scene(i) { return scenes.filter(function (s) { return s.getAttribute('data-i') === String(i); })[0]; }
    // the store drawings not in the light rest (assets/cg-apps-new.css): the browser skips them, so pinning lays out
    // one drawing, not six. One fading out rests once its fade is over.
    function rest() { restT = 0; scenes.forEach(function (s) { if (!s.classList.contains('on')) s.classList.add('an-sc-rest'); }); }
    function settle(sc, play) {
      if (!sc) return;
      var parts = all(sc, '.mo-x, .mo-y'), ok = sc.querySelector('.mo-ok');
      timers.forEach(clearTimeout); timers = [];
      if (!play) { on(parts); if (ok) ok.classList.add('on'); return; }
      off(parts); off(parts, 'flash'); if (ok) ok.classList.remove('on');
      timers.push(later(function () { parts.forEach(function (el) { el.classList.add('on'); if (el.classList.contains('mo-x')) el.classList.add('flash'); }); }, 0.45));
      if (ok) timers.push(later(function () { ok.classList.add('on'); }, 1.25));
    }
    function setActive(i) {
      if (i === cur) return;
      var prev = cur;
      cur = i;
      var end = i >= n;
      sec.classList.toggle('an-all', end);
      cats.forEach(function (c, k) { c.classList.toggle('on', k === i); });
      nodes.forEach(function (el) { el.classList.toggle('lit', end || el.getAttribute('data-c') === String(i)); });
      rays.forEach(function (el) { el.classList.toggle('lit', end || el.getAttribute('data-c') === String(i)); });
      if (end) { light.style.setProperty('--al', '1'); light.style.setProperty('--af', '0'); }
      else { light.style.setProperty('--al', cats[i].getAttribute('data-len')); light.style.setProperty('--af', cats[i].getAttribute('data-from')); }
      var si = end ? n - 1 : i;
      scenes.forEach(function (s) { var shown = s.getAttribute('data-i') === String(si); s.classList.toggle('on', shown); if (shown) s.classList.remove('an-sc-rest'); });
      clearTimeout(restT); restT = later(rest, 0.5);
      if (!(end && prev === n - 1)) settle(scene(si), true);
    }
    // pin only where the moment fits, decided again whenever the window changes size: a phone turned sideways gets
    // the still version, and turned back the pin returns. The height read is the small viewport (100svh, what the pin
    // is sized by), so a phone's toolbar sliding in and out on scroll never flips it, and pinning needs 40px more
    // than unpinning, so a window dragged across the line does not flicker. One read per frame while the window
    // changes; the page is only written, and measured again, when the answer flips.
    var pinned = false, sc = null, raf = 0;
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    var fits = function (need) { return (probe.offsetHeight || window.innerHeight) - MO.head() >= need; };
    function pinOn() {
      pinned = true;
      sec.classList.add('an-on');
      // the light starts on the first category, so nothing jumps when the moment arrives; nothing was fading
      cur = -1; setActive(0);
      clearTimeout(restT); rest();
      if (!sc) sc = MO.scene(sec, pin, function (p) { if (pinned) setActive(Math.min(n, Math.floor(p * (n + 1) * 0.999))); });
      else MO.remeasure();
    }
    function pinOff() {
      pinned = false;
      sec.classList.remove('an-on', 'an-all');
      cur = -1;
      settle(scene(0), false);
      MO.remeasure();
    }
    function decide() {
      raf = 0;
      if (MO.live && !pinned && fits(560)) pinOn();
      else if (pinned && !(MO.live && fits(520))) pinOff();
    }
    function soon() { if (!raf) raf = requestAnimationFrame(decide); }
    // while the page loads the first answer reads no layout (MO.tall); the next frame checks it against the small
    // viewport, after the kit has measured the page once
    if (MO.live && MO.tall(520)) pinOn(); else settle(scene(0), false);
    if (MO.live) requestAnimationFrame(function () { if (!MO.live) return; if (!pinned && fits(520)) pinOn(); else if (pinned && !fits(520)) pinOff(); });
    addEventListener('resize', soon);
    addEventListener('orientationchange', soon);
    // the Pause animations button: paused, the moment is unpinned and still, with the category that was in the light
    // kept in view; played again, it pins where it fits
    document.addEventListener('cg:motion', function () {
      if (MO.live) { if (!pinned && fits(520)) pinOn(); return; }
      if (!pinned) return;
      var r = sec.getBoundingClientRect(), inside = r.top <= MO.head() + 1 && r.bottom >= window.innerHeight, cat = cats[Math.max(0, cur)];
      pinOff();
      if (inside && cat) window.scrollTo(0, Math.round(cat.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - MO.head() - 16));
    });
  }

  // ---- (4) the list: chips filter it by category (a gentle glide where the browser has view transitions)
  function list(sec) {
    var chips = all(sec, '.an-chip-f'), rows = all(sec, '.an-row');
    if (!chips.length) return;
    sec.classList.add('an-js');
    function apply(f) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-f') === f ? 'true' : 'false'); });
      rows.forEach(function (r) { r.hidden = !(f === 'all' || r.getAttribute('data-cat') === f); });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-f');
        if (document.startViewTransition && MO.live) document.startViewTransition(function () { apply(f); });
        else apply(f);
      });
    });
  }

  // ---- (5) the team: the two cursors and the team's card arrive once
  function team(sec) {
    var parts = all(sec, '.an-team-pic .mo-y'), caret = sec.querySelector('.an-caret');
    // the caret blinks while the moment is on screen; off screen it waits where it was (#81)
    if (caret && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { caret.classList.toggle('an-away', !en[en.length - 1].isIntersecting); }).observe(sec);
    if (!MO.live) { on(parts); return; }
    MO.when(sec, 0.7, function () { parts.forEach(function (el, i) { later(function () { el.classList.add('on'); }, 0.2 + i * 0.45); }); });
  }

  all(PAGE, '.an-open').forEach(opening);
  all(PAGE, '.an-steps').forEach(steps);
  all(PAGE, '.an-stars').forEach(stars);
  all(PAGE, '.an-list').forEach(list);
  all(PAGE, '.an-team').forEach(team);
})();
